import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MealplanCode } from 'libraries/hotel/models/details';
import { Yii } from 'libraries/interfaces/Yii';
import { ILabels } from 'libraries/interfaces/ILabels';
import { ILanguageText } from 'libraries/hotel/models/quote';

import { faCoffee, IconDefinition, faBan } from "@fortawesome/free-solid-svg-icons";

export interface IDisplayedMeal {
    code?: string;
    name?: string;
}

@Component({
    selector: 'meal-plan',
    template: `
        <span class="container">
            <span class="icon-container">
                <fa-icon [icon]="iconCoffee"
                         class="icon"
                         [title]="labels.meal"
                         [ngClass]="meal.code"
                         *ngIf="hasMeal"></fa-icon>
                <fa-layers *ngIf="!hasMeal">
                    <fa-icon [icon]="iconCoffee" class="coffee" transform="shrink-8" class="icon-coffee"></fa-icon>
                    <fa-icon [icon]="iconBan" class="ban" transform="grow-2" class="icon-ban"></fa-icon>
                </fa-layers><!--
            --></span><!--
            --><span class="text-container"><!--
                --><span class="text meal-name"
                      *ngIf="meal?.name"
                      [title]="meal.code">{{ meal.name }}</span><!--
                --><span class="text meal-name"
                      *ngIf="!meal?.name">{{ meal.code }}</span>
            </span>

        </span>
    `,
    styles: [`

        .icon-container {
            width: 25px;
            display: inline-block;
        }

        .icon {
            width: 18px;
        }

        .icon.Unknown {
            color: #aaa;
        }

        .fa-sm {
            font-size: 0.62em;
            margin-right: 2px;

        }

        .icon-coffee {
            color: #666;

        }

        .icon-ban {
            color: #aaa
        }

        .text {
            flex: 1;
        }

    `]
})
export class MealPlanComponent implements OnChanges {
    @Input()
    public name: ILanguageText | string;

    /** Will be converted to string if a number is provided. */
    @Input()
    public code: string;

    public iconBan: IconDefinition = faBan;
    public iconCoffee: IconDefinition = faCoffee;

    public labels: ILabels = {
        meal: Yii.t("wui-shared-js", "Repas"),
    };

    public get hasMeal(): boolean {
        return this.code && (this.code.toLowerCase() !== MealplanCode.NoMealIncluded.toLowerCase());
    }

    public get meal(): IDisplayedMeal {
        const noName: string = Yii.t("wui-shared-js", "Non spécifié");
        if (this.code) {
            return {
                code: this.code,
                name: typeof this.name === 'string' ? this.name :
                    this.name && this.name.text ? this.name.text : this.code,
            };
        }
        return {
            code: MealplanCode.Unknown,
            name: Yii.t("wui-shared-js", "Non spécifié"),
        };
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.code && changes.code.currentValue && !Number.isNaN(changes.code.currentValue)) {
            this.code = String(this.code);
        }
    }

}
